angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("impersonate-template.html", "<div></div>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/impersonate/impersonate-template.html
 ** module id = 406
 ** module chunks = 0
 **/